module.exports = __webpack_public_path__ + "img/Image36.91bbd6cb.png";